<template>
  <div class="sl-Loader">
    <div v-for="row in ROWS" :key="row.id" class="sl-Loader_Row">
      <div class="sl-Cell">
        <SkeletonItem :size="XS" width="14px" />
      </div>
      <div class="sl-Cell">
        <SkeletonItem :size="XS" :width="row.name" />
      </div>
      <div class="sl-Cell">
        <SkeletonItem :size="XS" :width="row.provider" />
      </div>
      <div class="sl-Cell">
        <SkeletonItem :size="XS" width="48px" />
      </div>

      <div class="sl-Cell">
        <SkeletonItem :size="XS" :width="row.domains" />
      </div>

      <div class="sl-Cell">
        <SkeletonItem
          :color="row.active ? 'var(--grade-high-color-next)' : 'var(--dark-3)'"
          :width="row.active ? '57px' : '70px'"
          border-radius="6px"
          height="24px"
          style="opacity: 0.3"
        />
      </div>

      <div class="sl-Cell">
        <SkeletonItem :size="XS" :width="row.created || '180px'" />
      </div>
      <div class="sl-Cell">
        <SkeletonItem :appearance="SKELETON_APPEARANCES.SQUARE" :size="SKELETON_SIZES.SM" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SSOLoader'
})
</script>

<script setup>
import {
  SKELETON_APPEARANCES,
  SKELETON_SIZES
} from '@/utils/components-configurations/skeleton-item'

import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

const { XS } = SKELETON_SIZES
const ROWS = [
  {
    id: 0,
    name: '80px',
    provider: '55px',
    domains: '100px',
    active: false
  },
  {
    id: 1,
    name: '60px',
    provider: '90px',
    domains: '160px',
    active: true
  },
  {
    id: 2,
    name: '96px',
    provider: '80px',
    domains: '60px',
    active: true
  },
  {
    id: 3,
    name: '43px',
    provider: '60px',
    domains: '120px',
    active: false
  }
]
</script>

<style lang="scss" scoped>
.sl-Loader_Row {
  height: 45px;
  padding: 0 32px;
  display: flex;
  align-items: center;
}

.sl-Cell {
  display: flex;
  align-items: center;

  &:first-child {
    flex: 0 0 24px;
    padding-right: 8px;
  }

  &:nth-child(2) {
    flex: 1 1 100%;
    overflow: hidden;
    padding-right: 8px;
  }

  &:nth-child(3),
  &:nth-child(4) {
    flex: 0 0 100px;
  }

  &:nth-child(5) {
    flex: 0 0 340px;
  }

  &:nth-child(6) {
    flex: 0 0 119px;
  }

  &:nth-child(7) {
    flex: 0 0 200px;
  }

  &:last-child {
    flex: 0 0 24px;
  }
}
</style>
